import React, { useEffect } from 'react';
import { TrackingService } from '@rocheglobal/component-library/src/services/tracking';

interface TrackTibAnalyticsProps {
  fullSlug?: string;
  name?: string;
}

export const TrackTibAnalytics: React.FC<TrackTibAnalyticsProps> = ({ fullSlug = '', name = '' }) => {
  useEffect(() => {
    // Ensure fullSlug exists and meets the specified criteria
    if (fullSlug.startsWith('diagnostik')) {
      TrackingService.push({
        event: 'tib-page-visit',
        project_name: 'roche-dot-de',
        page_type: 'page',
        page_path: fullSlug,
        page_title: name,
      } as never);
    }
  }, [fullSlug, name]);

  return null; // This component does not render anything
};
